import {
  customRequest,
  customRequestArray,
  handleResponse,
  accountId,
} from "src/helpers";
import { buildQueryString } from "src/utils/helpers";

const config = {
  apiUrl: process.env.VUE_APP_BACKEND_URL,
};

export const invoiceService = {
  create,
  update,
  getAll,
  getById,
  getPdfById,
  delete: _delete,
  getNextNumber,
  sendEmail,
  logPayment,
  getStatementAll,
  getStatementSummary,
  createFromQuote,
  addAttachments,
  deleteAttachments,
  getByIdFiles,
  getByGuid,
  pay,
  void: _void,
};
function getByIdFiles(id) {
  const requestOptions = {
    ...customRequest("GET"),
  };

  return fetch(`${config.apiUrl}/Invoices/${id}/files`, requestOptions).then(
    handleResponse
  );
}

function addAttachments(payload) {
  payload.accountId = accountId();
  const requestOptions = {
    ...customRequestArray("POST", payload.attachmentIds),
  };

  return fetch(
    `${config.apiUrl}/Invoices/${payload.id}/files`,
    requestOptions
  ).then(handleResponse);
}

function deleteAttachments(payload) {
  payload.accountId = accountId();
  const requestOptions = {
    ...customRequestArray("DELETE", payload.attachmentIds),
  };

  return fetch(
    `${config.apiUrl}/Invoices/${payload.id}/files`,
    requestOptions
  ).then(handleResponse);
}

function pay(payload, id) {

  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
    },
    body: JSON.stringify(payload)
  }


  return fetch(
    `${config.apiUrl}/Public/invoice/${id}/payment`,
    requestOptions
  ).then(handleResponse);
}

function create(payload) {
  payload.invoice.accountId = accountId();
  const requestOptions = {
    ...customRequest("POST", payload),
  };
  return fetch(
    `${config.apiUrl}/Invoices/CreateWithLines`,
    requestOptions
  ).then(handleResponse);
}

function createFromQuote(payload) {
  const requestOptions = {
    ...customRequest("POST"),
  };
  return fetch(
    `${config.apiUrl}/Quotes/${payload.quoteId}/ConvertToInvoice`,
    requestOptions
  ).then(handleResponse);
}

function logPayment(payload) {
  payload.accountId = accountId();
  const requestOptions = {
    ...customRequest("POST", payload),
  };
  return fetch(
    `${config.apiUrl}/Invoices/${payload.id}/payment`,
    requestOptions
  ).then(handleResponse);
}

function sendEmail(payload) {
  payload.accountId = accountId();
  const requestOptions = {
    ...customRequest("POST", payload),
  };
  return fetch(
    `${config.apiUrl}/Invoices/${payload.id}/email`,
    requestOptions
  ).then(handleResponse);
}

function getNextNumber() {
  const requestOptions = {
    ...customRequest("GET"),
  };

  return fetch(`${config.apiUrl}/Invoices/NextNumber`, requestOptions)
    .then(handleResponse)
    .then((response) => {
      return {
        data: response,
      };
    });
}

function getAll(params = {}) {
  const requestOptions = {
    ...customRequest("GET"),
  };

  let queryString = buildQueryString(params);
  return fetch(`${config.apiUrl}/Invoices?${queryString}`, requestOptions)
    .then(handleResponse)
    .then((response) => {
      return response;
    });
}

function getStatementSummary(params = {}) {
  let queryString = buildQueryString(params);
  const requestOptions = {
    ...customRequest("GET"),
  };
  return fetch(
    `${config.apiUrl}/Invoices/Summary?${queryString}`,
    requestOptions
  )
    .then(handleResponse)
    .then((response) => {
      return {
        data: response,
      };
    });
}

function getStatementAll(params = {}) {
  let queryString = buildQueryString(params);

  const requestOptions = {
    ...customRequest("GET"),
  };
  return fetch(
    `${config.apiUrl}/Invoices/Statement?${queryString}`,
    requestOptions
  )
    .then(handleResponse)
    .then((response) => {
      return {
        data: response,
      };
    });
}

function getById(id) {
  const requestOptions = {
    ...customRequest("GET"),
  };

  return fetch(`${config.apiUrl}/Invoices/${id}`, requestOptions)
    .then(handleResponse)
    .then((response) => {
      return {
        data: response,
      };
    });
}

function getPdfById(id, admin) {
  const requestOptions = {
    ...customRequest("GET"),
  };

  if (admin) return fetch(`${config.apiUrl}/Invoices/${id}/download/admin`, requestOptions)
  else return fetch(`${config.apiUrl}/Invoices/${id}/download`, requestOptions)
}



function getByGuid(id) {
  const requestOptions = {
    ...customRequest("GET"),
  };

  return fetch(
    `${config.apiUrl}/Public/invoice/guid?guid=${id}`,
    requestOptions
  )
    .then(handleResponse)
    .then((response) => {
      return {
        data: response,
      };
    });
}

function update(payload) {
  let id = payload.id;
  delete payload.id;
  payload.invoice.accountId = accountId();
  const requestOptions = {
    ...customRequest("PUT", payload),
  };

  return fetch(
    `${config.apiUrl}/Invoices/${id}/UpdateWithLines`,
    requestOptions
  )
    .then(handleResponse)
    .then((response) => {
      return {
        data: response,
      };
    });
}

function _void(payload) {
  const requestOptions = {
    ...customRequest("POST", payload?.note ?? ''),
  };
  return fetch(`${config.apiUrl}/Invoices/${payload.id}/void`, requestOptions)
    .then(handleResponse)
    .then((response) => {
      return {
        data: {
          id: payload.id,
          ...response,
        },
      };
    });
}

function _delete(payload) {
  const requestOptions = {
    ...customRequest("DELETE"),
  };
  return fetch(`${config.apiUrl}/Invoices/${payload.id}`, requestOptions)
    .then(handleResponse)
    .then((response) => {
      return {
        data: {
          id: payload.id,
          ...response,
        },
      };
    });
}
